/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_Invalid_TypeInputs */

const vi_tea_purchase_payment_proof_invalid_type = /** @type {(inputs: Tea_Purchase_Payment_Proof_Invalid_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn file ảnh (PNG, JPG)`)
};

/**

* @param {Tea_Purchase_Payment_Proof_Invalid_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_invalid_type = /** @type {((inputs?: Tea_Purchase_Payment_Proof_Invalid_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_Invalid_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_invalid_type(inputs)
});